import {LoadingOverlay} from "@mantine/core";

export function FullPageSpinner(props?: any) {

    return (
        <div style={{position: "absolute", height: "100%", width: "100%", top: "0", left: "0"}}>
            <LoadingOverlay visible={true} {...props}/>
        </div>
    );
}